import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Space,
  message,
  Typography,
  Card,
  Input,
} from "antd";
import { DeleteOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { client } from "../../../../../../utils/api-client";
import { useAsync } from "../../../../../../utils/use-async";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Spinner } from "../../../../../lib";
// import './ProdFiles.css'; // Optional custom styles

const { Title } = Typography;

const ProdFiles = () => {
  const { run, data, isLoading } = useAsync();
  const [dataSource, setDataSource] = useState([]);
  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletingKey, setDeletingKey] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const fetchRecords = async () => {
    const res = await run(client("/prod/files"));
    setDataSource(res.data.files);
  };
  const showDeleteConfirm = (key) => {
    console.log(key);
    setDeletingKey(key);
    setIsModalOpen(true);
  };

  const handleDelete = () => {
    run(
      client(`prod/file/delete`, {
        method: "DELETE",
        body: { id: deletingKey },
      })
    )
      .then((res) => {
        message.success(res.message);
        setIsModalOpen(false);
        fetchRecords();
        setDeletingKey(null);
      })
      .catch((err) => {
        message.error(err.message);
        setIsModalOpen(false);
      });
  };

  const handleView = (fileName) => {
    history.push(`/target-report/manage/${fileName}`);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      message.error("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsModalVisible(true);

    // try {
    run(
      client(`upload/target/report`, {
        body: formData,
        type: "formData",
        method: "POST",
      })
        .then((res) => {
          message.success(res.message);
          setSelectedFile(null);
          fetchRecords();
          setIsModalVisible(false);
        })
        .catch((err) => {
          message.error(err.message);
        })
    );
    // } catch (error) {
    //   message.error("Failed to upload file");
    // } finally {
    //   setIsModalVisible(false);
    //   setUploadProgress(0);
    //   fetchRecords()
    // }
  };
  const columns = [
    {
      title: "📁 File Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <strong style={{ color: "#1677ff" }}>{text}</strong>,
    },
    {
      title: "⚙️ Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => handleView(record._id)}
          >
            View
          </Button>
          <Button
            type="default"
            danger
            icon={<DeleteOutlined />}
            onClick={() => showDeleteConfirm(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    fetchRecords();
  }, []);
  return (
    <div className="prod-container">
      <Card className="prod-card" bordered={false}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 16,
          }}
        >
          <Button
            icon={<UploadOutlined />}
            type="primary"
            onClick={() => setIsModalVisible(true)}
          >
            Upload File
          </Button>
        </div>
        <Title level={3} style={{ marginBottom: 20 }}>
          📊 Productivity Files
        </Title>
        <Table
          columns={columns}
          dataSource={dataSource}
          bordered
          pagination={{
            pageSize: 3,
            showSizeChanger: false,
            position: ["bottomCenter"],
          }}
          rowClassName="table-row"
        />
      </Card>

      <Modal
        title="Confirm Deletion"
        open={isModalOpen}
        onOk={handleDelete}
        onCancel={() => setIsModalOpen(false)}
        okText="Yes, Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>Do you really want to delete this file? This action is permanent.</p>
      </Modal>

      <Modal
        title="Upload File"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Input
          type="file"
          onChange={(e) => setSelectedFile(e.target.files[0])}
        />
        <div style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            onClick={handleUpload}
            disabled={!selectedFile}
          >
            {isLoading ? <Spinner /> : "Start Upload"}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ProdFiles;
